(function (global, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    global.NINTEVariantConsistencyV1 = api;
    function start() {
      api.boot(global, global.document);
    }
    function startAfterReadyCallbacks() {
      if (typeof global.setTimeout === 'function') {
        global.setTimeout(start, 0);
      } else {
        start();
      }
    }
    if (global.document.readyState !== 'complete') {
      global.document.addEventListener('DOMContentLoaded', startAfterReadyCallbacks, { once: true });
    } else {
      startAfterReadyCallbacks();
    }
  }
}(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var ROOT_SELECTOR = '[data-ninte-variant-consistency-root]';
  var OPTION_SELECTOR = '.single-option-selector[data-index]';
  var GALLERY_SETTLE_MS = 350;
  var states = [];
  var bootRecords = [];

  function clean(value) {
    return String(value == null ? '' : value).replace(/^\s+|\s+$/g, '');
  }

  function normalize(values) {
    return (values || []).map(clean).filter(function (value) {
      return value && value !== 'Default Title';
    });
  }

  function optionPosition(node) {
    var match = /^option([1-3])$/.exec(clean(node.getAttribute('data-index')));
    return match ? parseInt(match[1], 10) : null;
  }

  function readSelectedOptions(root) {
    var byPosition = {};
    Array.prototype.forEach.call(root.querySelectorAll(OPTION_SELECTOR), function (node) {
      var position = optionPosition(node);
      var type = clean(node.getAttribute('type')).toLowerCase();
      if (!position || ((type === 'radio' || type === 'checkbox') && !node.checked)) return;
      byPosition[position] = clean(node.value);
    });
    return Object.keys(byPosition).map(Number).sort(function (a, b) { return a - b; })
      .map(function (position) { return byPosition[position]; });
  }

  function syncMainSelectors(root, variant) {
    var values = variantOptions(variant);
    var updated = {};
    if (!root || !values.length) return 0;
    Array.prototype.forEach.call(root.querySelectorAll(OPTION_SELECTOR), function (node) {
      var position = optionPosition(node);
      var expected;
      var type;
      if (!position || position > values.length) return;
      expected = values[position - 1];
      type = clean(node.getAttribute('type')).toLowerCase();
      if (type === 'radio' || type === 'checkbox') {
        node.checked = clean(node.value) === expected;
      } else {
        node.value = expected;
      }
      updated[position] = true;
    });
    return Object.keys(updated).length;
  }

  function variantOptions(variant) {
    return normalize(variant && Array.isArray(variant.options) ? variant.options : [
      variant && variant.option1, variant && variant.option2, variant && variant.option3
    ]);
  }

  function resolveVariant(product, values) {
    var selected = normalize(values);
    var match = null;
    Array.prototype.forEach.call((product && product.variants) || [], function (variant) {
      var options = variantOptions(variant);
      if (options.length === selected.length && options.every(function (value, index) {
        return value === selected[index];
      })) match = variant;
    });
    return match;
  }

  function classify(variant) {
    if (!variant) return 'unavailable';
    return variant.available ? 'ready' : 'sold_out';
  }

  function nextEpoch(state) {
    state.epoch += 1;
    return state.epoch;
  }

  function isCurrentEpoch(state, epoch) {
    return state.epoch === epoch && !state.destroyed;
  }

  function mayApproveGallery(state, epoch, visibleMediaId, expectedMediaId) {
    return isCurrentEpoch(state, epoch) &&
      String(visibleMediaId || '') === String(expectedMediaId || '');
  }

  function claimRecovery(state, epoch) {
    if (state.recoveryEpoch === epoch) return false;
    state.recoveryEpoch = epoch;
    return true;
  }

  function variantMediaId(variant) {
    var image = variant && variant.featured_image;
    return clean((image && image.id) || (variant && variant.featured_image_id));
  }

  function galleryExpectation(product, variant) {
    var expectedMediaId = variantMediaId(variant);
    var uses = 0;
    if (expectedMediaId) {
      Array.prototype.forEach.call((product && product.variants) || [], function (candidate) {
        if (variantMediaId(candidate) === expectedMediaId) uses += 1;
      });
    }
    return {
      strict: !!expectedMediaId && uses === 1,
      expectedMediaId: expectedMediaId
    };
  }

  function visibleGalleryMediaId(root) {
    var visible = [];
    if (!root || typeof root.querySelectorAll !== 'function') return '';
    Array.prototype.forEach.call(
      root.querySelectorAll('.product-single__photo[data-image-id]'),
      function (photo) {
        var node = photo;
        var slide = null;
        var cloned = false;
        if (photo.classList && photo.classList.contains('hide')) return;
        while (node && node !== root) {
          if (node.classList && node.classList.contains('slick-cloned')) cloned = true;
          if (node.classList && node.classList.contains('slick-slide')) {
            slide = node;
            break;
          }
          node = node.parentNode;
        }
        if (cloned) return;
        if (slide && !slide.classList.contains('slick-current') &&
            slide.getAttribute('aria-hidden') !== 'false') return;
        visible.push(clean(photo.getAttribute('data-image-id')));
      }
    );
    return visible.length === 1 ? visible[0] : '';
  }

  function emitRubikRecovery(state, result, epoch) {
    var jq = state && state.window && state.window.jQuery;
    var target;
    if (typeof jq !== 'function') return false;
    target = jq(state.root);
    if (!target || typeof target.trigger !== 'function') return false;
    target.trigger({
      type: 'variantImageChange',
      variant: result.variant,
      ninteInternal: true,
      ninteEpoch: epoch
    });
    return true;
  }

  function reviewGallery(state, epoch, result, allowDegrade) {
    var expectation = galleryExpectation(state && state.product, result && result.variant);
    var visibleMediaId;
    if (!isCurrentEpoch(state, epoch)) return 'stale';
    if (!expectation.strict) return 'approved';
    visibleMediaId = visibleGalleryMediaId(state.root);
    if (mayApproveGallery(state, epoch, visibleMediaId, expectation.expectedMediaId)) {
      return 'approved';
    }
    if (claimRecovery(state, epoch)) {
      emitRubikRecovery(state, result, epoch);
      return 'recovering';
    }
    return allowDegrade ? 'degraded' : 'recovering';
  }

  function formInput(form) {
    return form && (form.idInput || form.querySelector('input[name="id"], select[name="id"]'));
  }

  function syncFormIds(forms, variant) {
    Array.prototype.forEach.call(forms || [], function (form) {
      var input = formInput(form);
      if (input && variant) input.value = String(variant.id);
    });
  }

  function formMatchesVariant(form, variant) {
    var input = formInput(form);
    return !!(input && variant && String(input.value) === String(variant.id));
  }

  function mayPurchase(status, formsMatch) {
    return status === 'ready' && formsMatch === true;
  }

  function statusCopy(status) {
    if (status === 'updating') return 'Updating your selection…';
    if (status === 'unavailable') return 'Unavailable — choose another combination';
    return '';
  }

  function setInteractive(node, enabled) {
    if (!node) return;
    node.disabled = !enabled;
    node.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    if (enabled) node.removeAttribute('data-ninte-purchase-blocked');
    else node.setAttribute('data-ninte-purchase-blocked', 'true');
  }

  function recordDiagnostic(state, code, details) {
    if (!state || state.diagnostics.length >= 5) return;
    state.diagnostics.push({
      code: clean(code),
      productId: clean(details && details.productId),
      variantId: clean(details && details.variantId),
      epoch: Number(details && details.epoch) || 0
    });
  }

  function parseProduct(root, documentObject) {
    var id = clean(root && (
      root.getAttribute('data-ninte-variant-section') ||
      root.getAttribute('data-section-id')
    ));
    var node;
    var product;
    if (!id || !documentObject || typeof documentObject.querySelector !== 'function') return null;
    node = documentObject.querySelector('#ProductJson-' + id);
    if (!node) return null;
    try {
      product = JSON.parse(node.textContent);
      return product && Array.isArray(product.variants) ? product : null;
    } catch (error) {
      return null;
    }
  }

  function recoverOptionControls(root) {
    var count = 0;
    if (!root || typeof root.querySelectorAll !== 'function') return count;
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-ninte-variant-option]'),
      function (control) {
        var wrapper = control.parentElement;
        control.disabled = false;
        control.removeAttribute('disabled');
        if (wrapper && wrapper.classList && wrapper.classList.contains('soldout')) {
          wrapper.classList.remove('soldout');
        }
        count += 1;
      }
    );
    return count;
  }

  function appendUnique(items, node) {
    if (node && items.indexOf(node) === -1) items.push(node);
  }

  function attributeSelectorValue(value) {
    return clean(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function sectionId(state) {
    return clean(state && state.root && (
      state.root.getAttribute('data-ninte-variant-section') ||
      state.root.getAttribute('data-section-id')
    ));
  }

  function formsFor(state) {
    var forms = [];
    var selector;
    var id = sectionId(state);
    if (!state || !state.root) return forms;
    Array.prototype.forEach.call(
      state.root.querySelectorAll('[data-ninte-variant-form]'),
      function (form) { appendUnique(forms, form); }
    );
    if (!id || !state.document || typeof state.document.querySelectorAll !== 'function') {
      return forms;
    }
    selector = '[data-sticky-add-to-cart]' +
      '[data-ninte-variant-section="' + attributeSelectorValue(id) + '"] ' +
      '[data-ninte-variant-form="sticky"]';
    Array.prototype.forEach.call(state.document.querySelectorAll(selector), function (form) {
      appendUnique(forms, form);
    });
    return forms;
  }

  function buttonsFor(state, forms) {
    var buttons = [];
    var selector = '[data-add-to-cart], [data-sticky-btn-addToCart], ' +
      'button[type="submit"][name="add"], input[type="submit"][name="add"]';
    Array.prototype.forEach.call(forms || formsFor(state), function (form) {
      Array.prototype.forEach.call(form.querySelectorAll(selector), function (button) {
        appendUnique(buttons, button);
      });
    });
    return buttons;
  }

  function paymentContainers(state) {
    return state && state.root ? state.root.querySelectorAll('.shopify-payment-button') : [];
  }

  function clearFormIds(forms) {
    Array.prototype.forEach.call(forms || [], function (form) {
      var input = formInput(form);
      if (input) input.value = '';
    });
  }

  function formsMatchVariant(forms, variant) {
    var matched = true;
    if (!forms || !forms.length || !variant) return false;
    Array.prototype.forEach.call(forms, function (form) {
      if (!formMatchesVariant(form, variant)) matched = false;
    });
    return matched;
  }

  function moneyFormatter(state) {
    var theme = state && state.window && state.window.theme;
    var currency = theme && theme.Currency;
    if (!currency || typeof currency.formatMoney !== 'function' || !theme.moneyFormat) {
      return null;
    }
    return function (cents) {
      return currency.formatMoney(Number(cents) || 0, theme.moneyFormat);
    };
  }

  function quantityFor(forms) {
    var quantity = 1;
    Array.prototype.forEach.call(forms || [], function (form) {
      var input;
      var parsed;
      if (quantity !== 1 || !form || typeof form.querySelector !== 'function') return;
      input = form.querySelector('[name="quantity"]');
      parsed = input ? parseInt(input.value, 10) : 1;
      if (isFinite(parsed) && parsed > 0) quantity = parsed;
    });
    return quantity;
  }

  function renderPrice(state, variant, forms) {
    var formatter;
    var quantity;
    var root = state && state.root;
    var priceNodes = root ? root.querySelectorAll('[data-price]') : [];
    var totalNodes = root ? root.querySelectorAll('[data-total-price]') : [];
    if (!variant) {
      Array.prototype.forEach.call(priceNodes, function (node) {
        node.classList.add('price--unavailable');
        node.setAttribute('aria-hidden', 'true');
      });
      return true;
    }
    if (!priceNodes.length && !totalNodes.length) return true;
    formatter = moneyFormatter(state);
    if (!formatter) return false;
    Array.prototype.forEach.call(priceNodes, function (node) {
      var regular = node.querySelector('[data-regular-price]');
      var sale = node.querySelector('[data-sale-price]');
      var compare = Number(variant.compare_at_price) || 0;
      var price = Number(variant.price) || 0;
      node.classList.remove('price--unavailable');
      node.removeAttribute('aria-hidden');
      if (compare > price) {
        node.classList.add('price--on-sale');
        if (regular) regular.textContent = formatter(compare);
        if (sale) sale.textContent = formatter(price);
      } else {
        node.classList.remove('price--on-sale');
        if (regular) regular.textContent = formatter(price);
        if (sale) sale.textContent = '';
      }
    });
    quantity = quantityFor(forms);
    Array.prototype.forEach.call(totalNodes, function (node) {
      node.textContent = formatter((Number(variant.price) || 0) * quantity);
      node.setAttribute('data-price-value', String(Number(variant.price) || 0));
    });
    return true;
  }

  function copyFromRoot(state, name, fallback) {
    var value = state && state.root ? state.root.getAttribute(name) : null;
    return clean(value) || fallback;
  }

  function renderStatus(state, status) {
    var node = state && state.root && state.root.querySelector('[data-product-status]');
    var copy = '';
    if (!node) return '';
    if (status === 'updating') {
      copy = copyFromRoot(state, 'data-ninte-updating-copy', statusCopy(status));
    } else if (status === 'unavailable') {
      copy = copyFromRoot(state, 'data-ninte-unavailable-copy', statusCopy(status));
    } else if (status === 'sold_out') {
      copy = copyFromRoot(state, 'data-ninte-sold-out-copy', 'Sold out');
    } else if (status === 'degraded') {
      copy = 'Please reselect the options to confirm the product images.';
    }
    node.textContent = copy;
    return copy;
  }

  function clearStatusTimer(state) {
    if (!state || state.statusTimer == null) return;
    if (state.window && typeof state.window.clearTimeout === 'function') {
      state.window.clearTimeout(state.statusTimer);
    }
    state.statusTimer = null;
  }

  function scheduleUpdatingStatus(state) {
    var epoch;
    if (!state || !state.window || typeof state.window.setTimeout !== 'function') return;
    clearStatusTimer(state);
    epoch = state.epoch;
    state.statusTimer = state.window.setTimeout(function () {
      state.statusTimer = null;
      if (isCurrentEpoch(state, epoch)) renderStatus(state, 'updating');
    }, 150);
  }

  function renderSku(state, variant) {
    var node = state && state.root && state.root.querySelector('.variant-sku');
    if (node) node.textContent = variant ? clean(variant.sku) : '';
  }

  function renderAvailability(state, status) {
    var node = state && state.root && state.root.querySelector('.product_inventory span');
    if (!node) return;
    if (status === 'ready') {
      node.textContent = copyFromRoot(state, 'data-ninte-in-stock-copy', 'In stock');
    } else if (status === 'sold_out') {
      node.textContent = copyFromRoot(state, 'data-ninte-out-of-stock-copy', 'Out of stock');
    } else if (status === 'unavailable') {
      node.textContent = '';
    }
  }

  function buttonCopy(state, status) {
    if (status === 'ready') {
      return copyFromRoot(state, 'data-ninte-add-to-cart-copy', 'Add to cart');
    }
    if (status === 'sold_out') {
      return copyFromRoot(state, 'data-ninte-sold-out-copy', 'Sold out');
    }
    if (status === 'unavailable') {
      return copyFromRoot(
        state,
        'data-ninte-unavailable-copy',
        'Unavailable — choose another combination'
      );
    }
    if (status === 'updating') {
      return copyFromRoot(state, 'data-ninte-updating-copy', 'Updating your selection…');
    }
    return 'Please reselect the options to confirm the product images.';
  }

  function renderButton(button, enabled, copy) {
    var text;
    setInteractive(button, enabled);
    text = typeof button.querySelector === 'function' ?
      button.querySelector('[data-add-to-cart-text]') : null;
    if (text) text.textContent = copy;
    else if (typeof button.value !== 'undefined') button.value = copy;
    button.setAttribute('aria-label', copy);
  }

  function renderPayment(node, enabled) {
    if (!node) return;
    node.inert = !enabled;
    if (enabled) {
      node.removeAttribute('aria-hidden');
      node.removeAttribute('inert');
      node.removeAttribute('data-ninte-purchase-blocked');
    } else {
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('inert', '');
      node.setAttribute('data-ninte-purchase-blocked', 'true');
    }
  }

  function dispatchCanonicalState(state, result) {
    var CustomEventConstructor = state && state.window && state.window.CustomEvent;
    if (!state || !state.root || typeof state.root.dispatchEvent !== 'function' ||
        typeof CustomEventConstructor !== 'function') return false;
    state.root.dispatchEvent(new CustomEventConstructor('ninte:variant-state', {
      bubbles: false,
      detail: {
        epoch: state.epoch,
        status: result.status,
        values: (result.values || []).slice(),
        variant: result.variant || null
      }
    }));
    return true;
  }

  function updateVariantUrl(windowObject, variant) {
    var url;
    if (!windowObject || !windowObject.location || !windowObject.history ||
        typeof windowObject.history.replaceState !== 'function' ||
        typeof URL !== 'function') return false;
    url = new URL(windowObject.location.href);
    if (variant && variant.id != null) url.searchParams.set('variant', String(variant.id));
    else url.searchParams.delete('variant');
    windowObject.history.replaceState(windowObject.history.state, '', url.toString());
    return true;
  }

  function renderCommerce(state, result) {
    var forms = formsFor(state);
    var buttons = buttonsFor(state, forms);
    var payments = paymentContainers(state);
    var variant = result && result.variant ? result.variant : null;
    var status = result && result.status ? result.status : classify(variant);
    var priceReady = true;
    var commitVariant = !!(result && result.commitVariant);
    var renderFields = status !== 'updating' || commitVariant;
    var fieldStatus = status === 'updating' && commitVariant ? classify(variant) : status;
    var idsMatch;
    var purchaseReady;
    var copy;
    if (variant && renderFields) syncFormIds(forms, variant);
    else if (status === 'unavailable') clearFormIds(forms);
    if (renderFields) {
      renderSku(state, variant);
      priceReady = renderPrice(state, variant, forms);
      renderAvailability(state, fieldStatus);
    }
    idsMatch = formsMatchVariant(forms, variant);
    purchaseReady = mayPurchase(status, idsMatch && priceReady);
    copy = buttonCopy(state, status);
    Array.prototype.forEach.call(buttons, function (button) {
      renderButton(button, purchaseReady, copy);
    });
    Array.prototype.forEach.call(payments, function (payment) {
      renderPayment(payment, purchaseReady);
    });
    if (status === 'updating') scheduleUpdatingStatus(state);
    else {
      clearStatusTimer(state);
      renderStatus(state, status);
    }
    dispatchCanonicalState(state, {
      status: status,
      values: result && result.values ? result.values : [],
      variant: variant
    });
    return purchaseReady;
  }

  function galleryRootFor(state) {
    if (!state || !state.root || typeof state.root.querySelector !== 'function') return null;
    return state.root.querySelector('.product-single__photos') ||
      state.root.querySelector('.slider-for') || state.root;
  }

  function clearGalleryTimer(state) {
    if (!state || state.galleryTimer == null) return;
    if (state.window && typeof state.window.clearTimeout === 'function') {
      state.window.clearTimeout(state.galleryTimer);
    }
    state.galleryTimer = null;
  }

  function stopGalleryApproval(state) {
    if (!state) return;
    clearGalleryTimer(state);
    if (state.galleryFrame != null && state.window &&
        typeof state.window.cancelAnimationFrame === 'function') {
      state.window.cancelAnimationFrame(state.galleryFrame);
    }
    state.galleryFrame = null;
    if (state.galleryObserver && typeof state.galleryObserver.disconnect === 'function') {
      state.galleryObserver.disconnect();
    }
    state.galleryObserver = null;
    state.galleryMayDegrade = false;
  }

  function hideGalleryCounter(state) {
    var counter = state && state.root && state.root.querySelector('[data-gallery-counter]');
    if (!counter) return;
    counter.hidden = true;
    counter.removeAttribute('data-gallery-counter-active');
  }

  function finishGalleryApproval(state, epoch, result, status) {
    var finalResult;
    if (!isCurrentEpoch(state, epoch)) return false;
    stopGalleryApproval(state);
    finalResult = {
      status: status,
      values: (result.values || []).slice(),
      variant: result.variant || null
    };
    if (status === 'degraded') {
      hideGalleryCounter(state);
      recordDiagnostic(state, 'gallery-mismatch', {
        productId: state.product && state.product.id,
        variantId: result.variant && result.variant.id,
        epoch: epoch
      });
    }
    renderCommerce(state, finalResult);
    state.currentResult = finalResult;
    return true;
  }

  function scheduleGalleryReview(state, epoch, result, allowDegrade) {
    var requestFrame = state.window && state.window.requestAnimationFrame;
    var cancelFrame = state.window && state.window.cancelAnimationFrame;
    if (allowDegrade) state.galleryMayDegrade = true;
    function review() {
      var outcome;
      state.galleryFrame = null;
      outcome = reviewGallery(state, epoch, result, state.galleryMayDegrade === true);
      if (outcome === 'approved') {
        finishGalleryApproval(state, epoch, result, 'ready');
      } else if (outcome === 'degraded') {
        finishGalleryApproval(state, epoch, result, 'degraded');
      }
    }
    if (state.galleryFrame != null && typeof cancelFrame === 'function') {
      cancelFrame.call(state.window, state.galleryFrame);
    }
    if (typeof requestFrame !== 'function') {
      review();
      return null;
    }
    state.galleryFrame = requestFrame.call(state.window, review);
    return state.galleryFrame;
  }

  function startGalleryApproval(state, result) {
    var expectation = galleryExpectation(state.product, result.variant);
    var epoch = state.epoch;
    var galleryRoot;
    var MutationObserverConstructor;
    if (!expectation.strict) return false;
    stopGalleryApproval(state);
    renderCommerce(state, {
      status: 'updating',
      values: result.values,
      variant: result.variant,
      commitVariant: true
    });
    state.currentResult = {
      status: 'updating',
      values: (result.values || []).slice(),
      variant: result.variant
    };
    galleryRoot = galleryRootFor(state);
    MutationObserverConstructor = state.window && state.window.MutationObserver;
    if (galleryRoot && typeof MutationObserverConstructor === 'function') {
      state.galleryObserver = new MutationObserverConstructor(function () {
        scheduleGalleryReview(state, epoch, result, false);
      });
      state.galleryObserver.observe(galleryRoot, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden'],
        childList: true,
        subtree: true
      });
    }
    scheduleGalleryReview(state, epoch, result, false);
    if (state.window && typeof state.window.setTimeout === 'function') {
      state.galleryTimer = state.window.setTimeout(function () {
        state.galleryTimer = null;
        scheduleGalleryReview(state, epoch, result, true);
      }, GALLERY_SETTLE_MS);
    }
    return true;
  }

  function syncState(state) {
    var values;
    var variant;
    var result;
    stopGalleryApproval(state);
    recoverOptionControls(state && state.root);
    values = readSelectedOptions(state.root);
    variant = resolveVariant(state.product, values);
    result = {
      status: classify(variant),
      values: values,
      variant: variant
    };
    updateVariantUrl(state.window, variant);
    if (result.status !== 'ready' || !startGalleryApproval(state, result)) {
      renderCommerce(state, result);
      state.currentResult = result;
    }
    return result;
  }

  function scheduleSync(state) {
    var epoch = nextEpoch(state);
    var values = readSelectedOptions(state.root);
    var variant = resolveVariant(state.product, values);
    var requestFrame = state.window && state.window.requestAnimationFrame;
    var cancelFrame = state.window && state.window.cancelAnimationFrame;
    clearStatusTimer(state);
    renderCommerce(state, {
      status: 'updating',
      values: values,
      variant: variant
    });
    if (state.syncFrame != null && typeof cancelFrame === 'function') {
      cancelFrame.call(state.window, state.syncFrame);
    }
    if (typeof requestFrame !== 'function') {
      if (isCurrentEpoch(state, epoch)) syncState(state);
      return epoch;
    }
    state.syncFrame = requestFrame.call(state.window, function () {
      state.syncFrame = null;
      if (isCurrentEpoch(state, epoch)) syncState(state);
    });
    return epoch;
  }

  function stateForRoot(root) {
    var match = null;
    Array.prototype.forEach.call(states, function (state) {
      if (!state.destroyed && state.root === root) match = state;
    });
    return match;
  }

  function optionControlBelongsToRoot(root, control) {
    var found = false;
    if (!root || !control || typeof root.querySelectorAll !== 'function') return false;
    Array.prototype.forEach.call(root.querySelectorAll(OPTION_SELECTOR), function (candidate) {
      if (candidate === control) found = true;
    });
    return found;
  }

  function closest(node, selector) {
    if (!node || typeof node.closest !== 'function') return null;
    return node.closest(selector);
  }

  function applyStickySelection(state, event, scheduler) {
    var swatch = closest(event && event.target, '.pr-swatch[data-value]');
    var sticky = swatch && closest(swatch, '[data-sticky-add-to-cart]');
    var expectedSection = sectionId(state);
    var stickySection = clean(sticky && sticky.getAttribute('data-ninte-variant-section'));
    var variantId = clean(swatch && swatch.getAttribute('data-value'));
    var variant = null;
    if (!swatch || !sticky || (expectedSection && stickySection !== expectedSection)) return null;
    Array.prototype.forEach.call((state.product && state.product.variants) || [], function (candidate) {
      if (String(candidate.id) === variantId) variant = candidate;
    });
    if (!variant) return null;
    syncMainSelectors(state.root, variant);
    (scheduler || scheduleSync)(state);
    return variant;
  }

  function writeSubmissionMessage(state, copy) {
    var node = state && state.root && state.root.querySelector('[data-product-status]');
    if (node) node.textContent = copy;
  }

  function guardSubmission(state, event) {
    var form = event && event.target;
    var forms = formsFor(state);
    var values;
    var variant;
    var allowed;
    var result;
    if (!form || forms.indexOf(form) === -1) return true;
    values = readSelectedOptions(state.root);
    variant = resolveVariant(state.product, values);
    allowed = !!(
      variant && variant.available && formsMatchVariant(forms, variant) &&
      state.currentResult && state.currentResult.status === 'ready' &&
      state.currentResult.variant && String(state.currentResult.variant.id) === String(variant.id)
    );
    if (allowed) return true;
    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    result = syncState(state);
    if (result.status === 'ready' && state.currentResult &&
        state.currentResult.status === 'ready') {
      writeSubmissionMessage(state, 'Selection updated — please add to cart again.');
    }
    return false;
  }

  function destroyState(state) {
    var index;
    if (!state || state.destroyed) return false;
    state.destroyed = true;
    clearStatusTimer(state);
    stopGalleryApproval(state);
    if (state.syncFrame != null && state.window &&
        typeof state.window.cancelAnimationFrame === 'function') {
      state.window.cancelAnimationFrame(state.syncFrame);
    }
    state.syncFrame = null;
    if (state.root && typeof state.root.removeEventListener === 'function' && state.onChange) {
      state.root.removeEventListener('change', state.onChange, true);
    }
    if (state.document && typeof state.document.removeEventListener === 'function' && state.onSticky) {
      state.document.removeEventListener('click', state.onSticky, true);
    }
    if (state.observer && typeof state.observer.disconnect === 'function') {
      state.observer.disconnect();
    }
    index = states.indexOf(state);
    if (index !== -1) states.splice(index, 1);
    return true;
  }

  function bindRoot(windowObject, documentObject, root) {
    var existing = stateForRoot(root);
    var product;
    var state;
    if (existing) return existing;
    product = parseProduct(root, documentObject);
    if (!product) return null;
    state = {
      root: root,
      product: product,
      document: documentObject,
      window: windowObject,
      epoch: 0,
      destroyed: false,
      diagnostics: [],
      recoveryEpoch: null,
      statusTimer: null,
      syncFrame: null,
      observer: null,
      galleryFrame: null,
      galleryTimer: null,
      galleryObserver: null,
      galleryMayDegrade: false
    };
    state.onChange = function (event) {
      if (optionControlBelongsToRoot(root, event && event.target)) scheduleSync(state);
    };
    state.onSticky = function (event) {
      applyStickySelection(state, event);
    };
    if (root && typeof root.addEventListener === 'function') {
      root.addEventListener('change', state.onChange, true);
    }
    if (documentObject && typeof documentObject.addEventListener === 'function') {
      documentObject.addEventListener('click', state.onSticky, true);
    }
    states.push(state);
    scheduleSync(state);
    return state;
  }

  function appendRoots(scope, roots) {
    if (!scope) return roots;
    if (typeof scope.getAttribute === 'function' &&
        scope.getAttribute('data-ninte-variant-consistency-root') != null) {
      appendUnique(roots, scope);
    }
    if (typeof scope.querySelectorAll === 'function') {
      Array.prototype.forEach.call(scope.querySelectorAll(ROOT_SELECTOR), function (root) {
        appendUnique(roots, root);
      });
    }
    return roots;
  }

  function statesForDocument(documentObject) {
    return states.filter(function (state) {
      return !state.destroyed && state.document === documentObject;
    });
  }

  function stateForForm(documentObject, form) {
    var match = null;
    Array.prototype.forEach.call(statesForDocument(documentObject), function (state) {
      if (!match && formsFor(state).indexOf(form) !== -1) match = state;
    });
    return match;
  }

  function bootRecordFor(documentObject) {
    var match = null;
    Array.prototype.forEach.call(bootRecords, function (record) {
      if (record.document === documentObject) match = record;
    });
    return match;
  }

  function targetOwnsRoot(target, root) {
    if (!target || !root) return false;
    if (target === root) return true;
    return typeof target.contains === 'function' && target.contains(root);
  }

  function boot(windowObject, documentObject) {
    var record;
    var roots = [];
    if (!windowObject || !documentObject) return 0;
    record = bootRecordFor(documentObject);
    if (!record) {
      record = {
        window: windowObject,
        document: documentObject
      };
      record.onSubmit = function (event) {
        var state = stateForForm(documentObject, event && event.target);
        if (state) guardSubmission(state, event);
      };
      record.onSectionLoad = function (event) {
        var loaded = [];
        appendRoots(event && event.target, loaded);
        Array.prototype.forEach.call(loaded, function (root) {
          bindRoot(windowObject, documentObject, root);
        });
      };
      record.onSectionUnload = function (event) {
        Array.prototype.forEach.call(statesForDocument(documentObject).slice(), function (state) {
          if (targetOwnsRoot(event && event.target, state.root)) destroyState(state);
        });
      };
      record.onPageShow = function () {
        Array.prototype.forEach.call(statesForDocument(documentObject), function (state) {
          scheduleSync(state);
        });
      };
      if (typeof documentObject.addEventListener === 'function') {
        documentObject.addEventListener('submit', record.onSubmit, true);
        documentObject.addEventListener('shopify:section:load', record.onSectionLoad);
        documentObject.addEventListener('shopify:section:unload', record.onSectionUnload);
      }
      if (typeof windowObject.addEventListener === 'function') {
        windowObject.addEventListener('pageshow', record.onPageShow);
      }
      bootRecords.push(record);
    }
    appendRoots(documentObject, roots);
    Array.prototype.forEach.call(roots, function (root) {
      bindRoot(windowObject, documentObject, root);
    });
    return statesForDocument(documentObject).length;
  }

  return {
    boot: boot,
    bindRoot: bindRoot,
    buttonsFor: buttonsFor,
    claimRecovery: claimRecovery,
    classify: classify,
    clearStatusTimer: clearStatusTimer,
    clearFormIds: clearFormIds,
    dispatchCanonicalState: dispatchCanonicalState,
    destroyState: destroyState,
    formMatchesVariant: formMatchesVariant,
    formsFor: formsFor,
    galleryExpectation: galleryExpectation,
    guardSubmission: guardSubmission,
    isCurrentEpoch: isCurrentEpoch,
    mayPurchase: mayPurchase,
    mayApproveGallery: mayApproveGallery,
    nextEpoch: nextEpoch,
    normalize: normalize,
    parseProduct: parseProduct,
    readSelectedOptions: readSelectedOptions,
    recordDiagnostic: recordDiagnostic,
    recoverOptionControls: recoverOptionControls,
    renderCommerce: renderCommerce,
    renderPrice: renderPrice,
    renderStatus: renderStatus,
    reviewGallery: reviewGallery,
    resolveVariant: resolveVariant,
    scheduleSync: scheduleSync,
    applyStickySelection: applyStickySelection,
    setInteractive: setInteractive,
    statusCopy: statusCopy,
    syncFormIds: syncFormIds,
    syncMainSelectors: syncMainSelectors,
    syncState: syncState,
    updateVariantUrl: updateVariantUrl,
    variantOptions: variantOptions,
    visibleGalleryMediaId: visibleGalleryMediaId
  };
}));
